import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { Observable } from 'rxjs';
import { EnderecoFabrilVO } from '../shared/model/endereco-fabril-vo.model';

@Injectable({
  providedIn: 'root'
})
export class EnderecoFabrilEntidadeService {

  private readonly url: string = '/sepin-backend/rest/endereco-fabril-entidades';
  constructor(private readonly http: McticHttpClient) {
  }

  obterPorComposicao(idComposicaoRda: number): Observable<EnderecoFabrilVO> {
    return this.http.get<EnderecoFabrilVO>(`${this.url}/${idComposicaoRda}`);
  }

  obterEnderecoEmpresas(idComposicoes: number[]): Observable<EnderecoFabrilVO[]> {
    return this.http.get<EnderecoFabrilVO[]>(`${this.url}/composicoes?ids=${idComposicoes}`);
  }

}
